import i18next from "i18next";
import { toast } from "react-toastify";
import { toast as sonnerToast } from "sonner";

export const generateErrorsConfigForForm = (fields, error) => {
	if (error === null) {
		return fields.map((name) => ({ name, errors: [] }));
	} else if (typeof error === "string") {
		return [];
	} else if (typeof error === "object") {
		return Object.entries(error).map(([name, errors]) => ({
			name,
			errors,
		}));
	} else {
		return [];
	}
};

export const isCancelError = (e) => {
	return e?.message === "canceled";
};

export const getErrorMessage = (err, t) => {
	if (err?.code === "ERR_CANCELED" || err?.message === "canceled" || isCancelError(err)) {
		return;
	} else if (typeof err === "string") {
		toast.error(err, { autoClose: 3000 });
	} else {
		toast.error(t("something-went-wrong"), { autoClose: 3000 });
	}
};

export const getSonnerErrorMessage = (err, t) => {
	if (err?.code === "ERR_CANCELED" || err?.message === "canceled" || isCancelError(err)) {
		return;
	} else if (typeof err === "string") {
		sonnerToast.error(err);
	} else {
		sonnerToast.error(t("something-went-wrong"));
	}
};

export const getToastErrorMessage = (
	e,
	defaultError = i18next.t("something-went-wrong"),
) => {
	if (typeof e === "string") {
		return e;
	}
	return defaultError;
};

// The messages of a time sheet batch error (`PUT /time-sheet/batch`, `/time-sheet/weekly/batch`):
// the backend sends `{ 0: { <addedId>: [{ field?, constraints }] }, <id>: [{ field?, constraints }] }`,
// `constraints` an array or an object of messages. Each message once, in order.
export const getBatchErrorMessages = (err) => {
	if (typeof err === "string") {
		return [err];
	}
	if (!err || typeof err !== "object") {
		return [];
	}
	const messages = [];
	const collect = (items) => {
		Object.values(items || {}).forEach((errors) => {
			if (!Array.isArray(errors)) {
				return;
			}
			errors.forEach((error) => {
				Object.values(error?.constraints || {}).forEach((message) => {
					if (typeof message === "string" && !messages.includes(message)) {
						messages.push(message);
					}
				});
			});
		});
	};
	const { 0: added, ...updated } = err;
	collect(added);
	collect(updated);
	return messages;
};

export const getBatchToastErrorMessage = (
	err,
	defaultError = i18next.t("something-went-wrong"),
) => {
	const messages = getBatchErrorMessages(err);
	return messages.length ? messages.join("\n") : defaultError;
};
